import React, { memo } from 'react';

import cx from 'classnames';
import { Key } from 'ts-key-enum';

import { imageUrl } from 'lane-shared/helpers/formatters';
import { getDisplayProfileName } from 'lane-shared/helpers/getDisplayName';
import { useTrackChannelView } from 'lane-shared/hooks/analytics';
import { Channel } from 'packages/lane-shared/types/ChannelType';

import Thumbnail from '../general/Thumbnail';

import styles from './DirectoryThumbnail.scss';

type Props = {
  className?: string;
  channel: Channel;
  onClick?: (e: any) => void;
  style?: React.CSSProperties;
};

function DirectoryThumbnail({ className, channel, onClick, style }: Props) {
  useTrackChannelView(channel);

  return (
    <div
      className={cx(styles.DirectoryThumbnail, className)}
      style={style}
      role="button"
      tabIndex={0}
      onKeyDown={e => e.key === Key.Enter && onClick?.(e)}
      onClick={onClick}
    >
      <Thumbnail
        className={styles.imageWrapper}
        src={
          imageUrl(channel.profile?.logo) || imageUrl(channel.profile?.image)
        }
        name={channel.name || ''}
      />
      <div className={styles.textWrapper}>
        <p>{getDisplayProfileName(channel)}</p>
      </div>
    </div>
  );
}

export default memo(DirectoryThumbnail);
